export default "__VITE_ASSET__C_MrWLC4__"